<template>
    <FilterDialog
        label="Команда"
        :summary="summaryText"
        :disabled="disabled"
        @open="onOpen"
        @apply="onApply"
        @cancel="onCancel"
    >
        <div class="team-filter-options" role="radiogroup" aria-label="Команда">
            <label
                v-for="option in teamOptions"
                :key="option.value"
                class="ui-control__option"
            >
                <input
                    v-model="draftValue"
                    type="radio"
                    :name="radioName"
                    :value="option.value"
                    :disabled="disabled"
                />
                <span class="ui-control__option-name">{{ option.label }}</span>
            </label>
        </div>
    </FilterDialog>
</template>

<script setup>
import { computed, ref } from 'vue';
import FilterDialog from '@/components/ui/forms/FilterDialog.vue';

let nextRadioGroup = 0;

const props = defineProps({
    teams: { type: Array, default: () => [] },
    modelValue: { type: [Number, String], default: null },
    disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'change']);

const radioName = `team-filter-${nextRadioGroup += 1}`;
const draftValue = ref('all');

const internalValue = computed(() => {
    if (props.modelValue == null || props.modelValue === '') {
        return 'all';
    }
    return String(props.modelValue);
});

const teamOptions = computed(() => [
    { value: 'all', label: 'Все команды' },
    ...[...props.teams]
        .sort((a, b) => Number(a.id) - Number(b.id))
        .map((team) => ({
            value: String(team.id),
            label: team.name || team.short_name || `Команда #${team.id}`,
        })),
]);

const summaryText = computed(() => {
    if (internalValue.value === 'all') {
        return 'Все команды';
    }

    const option = teamOptions.value.find((item) => item.value === internalValue.value);
    return option?.label || 'Команда';
});

function onOpen() {
    draftValue.value = internalValue.value;
}

function onCancel() {
    draftValue.value = internalValue.value;
}

function onApply() {
    const next = draftValue.value === 'all' || draftValue.value == null || draftValue.value === ''
        ? null
        : Number(draftValue.value);
    const current = props.modelValue == null || props.modelValue === '' ? null : Number(props.modelValue);

    if (next === current) {
        return;
    }

    emit('update:modelValue', next);
    emit('change', next);
}
</script>
